<template>
  <b-card>
    <template v-slot:header>
      <span class="breadcrumbs"><b-link :to="{name: `sequence`}">{{collection | capitalise | pluralise}}</b-link> / Batch Create</span>
    </template>

    <b-alert :show="current_period_usage === null || (current_period_usage && current_period_usage.left < 1)" variant='warning'>
      You can't add any more contacts. Please upgrade your plan<span v-if="current_period_usage"> or wait until it resets on {{current_period_usage.resets | date}}</span>.
    </b-alert>

    <div class="input-table mb-2">
      <hot-table :settings="table_settings" ref="data_table"></hot-table>
    </div>

    <LoadingButton :loading="loading" @click="create_batch" v-if='current_period_usage && current_period_usage.left >= 1'>Add</LoadingButton>
  </b-card>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import ConstantsMixin from "@/mixins/Constants.js"
import { db, FieldValue } from '@/main.js'
import moment from 'moment/src/moment'

import { HotTable } from '@handsontable/vue'

export default {
  metaInfo: {title: 'Recipient batch create'},
  mixins: [ItemMixin, ConstantsMixin],
  props: ['profile'],
  components: {HotTable},
  validations: {
    item: {
    }
  },
  mounted() {
    if (this.$refs.data_table && this.$refs.data_table.hotInstance) {
      this.$refs.data_table.hotInstance.render()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'sequence') {
      next()
      return
    }

    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  data() {
    let variables = []
    let headers = ['Email', 'First name', 'Last name', 'Organisation', 'Website URL', 'Custom 1', 'Custom 2', 'Custom 3', 'Custom 4', 'Timezone Offset']
    let columns = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]

    return {
      table_settings: {
        data: [],
        columns: columns,
        colHeaders: headers,
        // colHeaders: true,
        rowHeaders: true,
        minSpareRows: 10,
        maxRows: 100,
        width: '100%',
        stretchH: 'all',
        height: '100%',
        licenseKey: 'non-commercial-and-evaluation',
      },
      param: 'recipient',
      collection: 'recipient',
      data: [],
      variables: variables,
      loading: false,
    }
  },
  computed: {
    current_period_usage() {
      if (!this.profile.team.current_period) {
        return null
      } else if (this.profile.team.current_period.id) {
        let used = 0
        if (this.profile.team.current_period.usage[this.profile.id]) {
          used = this.profile.team.current_period.usage[this.profile.id].recipients || 0
        }
        let total = this.profile.team.current_period.max_usage_in_period_per_user
        let left = total - used
        let resets = this.profile.team.current_period.current_period_end

        return {used: used, total: total, left: left, resets: resets}
      }

      return undefined
    }
  },
  methods: {
    async create_batch() {
      this.loading = true
      let rows = this.$refs.data_table.hotInstance.getData()

      let items = []
      for (let row_i in rows) {
        let row = rows[row_i]
        let all_null = true
        for (let col of row) {
          if (col !== null && col.trim() !== '') {
            all_null = false
          }
        }

        if (all_null) {
          continue
        }

        let item = {
          updated: new Date(),
          created: new Date(),
          team: db.collection('team').doc(this.profile.team.id),
          user: db.collection('user').doc(this.profile.id),
          completed_steps: [],
          items: [],
          next_step: null,
          next_step_date: null,
          task_status: 'pending',
          status: 'pending',// TODO this.constants.lead_status.not_started,
          timezone_offset: Number(row[9]) || (this.profile.default_timezone_offset || 0),
          email: row[0],
          first_name: row[1],
          last_name: row[2],
          organisation: row[3],
          website: row[4],
          custom_1: row[5],
          custom_2: row[6],
          custom_3: row[7],
          custom_4: row[8],
        }

        if (!item.email || !item.email.match(/[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/) || !item.first_name) {
          this.$swal({title: 'Invalid data', text: "You must have valid emails and first names", icon: 'warning'})
          this.loading = false
          return
        }

        item.website = null
        if (row[4] && row[4].trim() != '') {
          let website_url = row[4]
          if (!website_url.match(/https?:\/\//i)) {
            website_url = `http://${website_url}`
          }

          item.website = website_url
        }

        items.push(item)
      }

      if (items.length === 0) {
        this.loading = false
        this.$swal({title: 'Add recipient', text: "Please add at least one recipient", icon: 'warning'})
        return
      }

      if ((this.current_period_usage.left - items.length) < 0) {
        this.loading = false
        this.$swal({title: 'Too many recipients', text: `You added ${items.length} recipients but you only have ${this.current_period_usage.left} left in your plan. Please upgrade or wait until your plan resets.`, icon: 'warning'})
        return
      }

      let proms = []
      for (let item of items) {
        let item_id = db.collection('item').doc().id
        proms.push(db.collection('sequence').doc(this.$route.params.id).collection('recipient').doc(item_id).set(item))
      }

      await Promise.all(proms)

      await this.$swal({title: 'Recipients imported', text: `${items.length} items have been added to your sequence`, icon: 'success'})

      this.loading = false

      this.$router.push({name: 'sequence'})
    }
  }
}
</script>

<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style>
.input-table {
    height: 280px;
}
</style>
